/* eslint-disable @intercom/intercom/no-bare-strings */
/* RESPONSIBLE TEAM: team-standalone */

import { type ConversationExtractionRowData } from './definitions';
import type SalesforcePlatform from '../salesforce';
import type ZendeskPlatform from '../zendesk';

export const GenericConversationExtractionRowData: ConversationExtractionRowData = {
  icon: 'circle-filled',
  title: 'Unknown source',
} as const;

export class SalesforceConversationExtractionRow implements ConversationExtractionRowData {
  private platform: SalesforcePlatform;

  constructor(platform: SalesforcePlatform) {
    this.platform = platform;
  }

  get icon() {
    return 'salesforce' as const;
  }

  get title() {
    if (this.platform.salesforceConfig?.isConnected) {
      return this.platform.salesforceConfig?.domain ?? '';
    }
    return this.platform.intl.t(
      'knowledge-hub.overview.sections.conversation-extraction.rows.active.title.salesforce',
    );
  }
}

export class ZendeskConversationExtractionRow implements ConversationExtractionRowData {
  private platform: ZendeskPlatform;

  constructor(platform: ZendeskPlatform) {
    this.platform = platform;
  }

  get icon() {
    return 'zendesk' as const;
  }

  get title() {
    if (this.platform.zendeskConfig?.isConnected) {
      return `${this.platform.zendeskConfig?.subdomain}.zendesk.com`;
    }
    return this.platform.intl.t(
      'knowledge-hub.overview.sections.conversation-extraction.rows.active.title.zendesk',
    );
  }
}
